const API_BASE = process.env.REACT_APP_API_URL || 'https://rytwhv6cal.execute-api.ap-southeast-6.amazonaws.com/dev';

export const otpService = {
  async sendOTP(email: string, purpose: string): Promise<void> {
    const response = await fetch(`${API_BASE}/otp/send`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, purpose })
    });

    if (!response.ok) {
      throw new Error('Failed to send OTP');
    }
  },

  async verifyOTP(email: string, code: string): Promise<boolean> {
    const response = await fetch(`${API_BASE}/otp/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, code })
    });

    if (!response.ok) {
      throw new Error('Failed to verify OTP');
    }

    const data = await response.json();
    return data.valid;
  }
};
